import { Button, Dialog, DialogTitle, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap';
import BillingService from '../../Services/billing/BillingService';
import ChecklistService from '../../Services/ChecklistService';
import Home from '../home/Home';
import Snacbar from '../Snacbar';
import { getDate, getPointId, getUserId } from '../Utils/Common';
import { ToggleButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";

const jobentrylablestyle = {
    color: 'grey',
    fontWeight: 'bolder',
    fontFamily: 'Times New Roman',
}
const ItemPap = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black'
}));
const ItemPap2 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'right',
    color: theme.palette.text.secondary,
    border: '1px solid black'
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: theme.palette.common.black,
        backgroundColor: 'rgb(61, 195, 177)',
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 15,
        fontFamily: 'Times New Roman',
        textAlign: 'center'
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: 'white',
        color: 'black'
    },
}));
function CheckListVerify() {
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [message, setMessage] = useState('');

    const [nonUplodedetails, setnonUplodedetails] = useState([]);
    const [Uplodedetails, setUplodedetails] = useState([]);
    const [ImporterDetails, setImporterDetails] = useState([]);
    const [JobTrackingDetails, setJobTrackingDetails] = useState([]);
    const [ChecklistAPPVERISUBMISSION, setChecklistAPPVERISUBMISSION] = useState([]);

    const [values, setValues] = useState({
        txt_customer: '', txt_jobNo: '', txt_clVerifySts: '', txt_clVerifyDate: getDate(),
        txt_clVerifyRemarks: ''
    });

    const [consigment, setConsigment] = useState('')

    const [jobentryDetails, setjobentryDetails] = useState({
        txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
        ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '',
        txt_asClearancePort: '', txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: 'MAWB.No', lbl_asAirlinesName: 'AirlinesName',
        lbl_asHawbNo: 'HAWB.No',
    });

    //OnChangeEvente
    const CustomerChangeHandle = (e) => {
        setValues({ ...values, txt_customer: e.target.value });
        getJobNoConsoleNonUpload(e.target.value, values.txt_jobNo);
    }

    const JobNoChangeHandle = (e) => {
        setValues({ ...values, txt_jobNo: e.target.value });
        var consigmnt, importer_iec_no = '';
        if (e.target.value === '') { consigmnt = '-1' }
        else { consigmnt = e.target.value }
        if (values.txt_customer === '') { importer_iec_no = '-1'; }
        else { importer_iec_no = values.txt_customer; }
        let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '4' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonUplodedetails(res.data); });
        BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setUplodedetails(res.data); });
    }

    const ClVerifyStsChangeHandle = (e) => {
        setValues({ ...values, txt_clVerifySts: e.target.value });
    }
    const ClverifyDateChangeHandle = (e) => {
        setValues({ ...values, txt_clVerifyDate: e.target.value });
    }
    const ClVerifyRemarksChangeHandle = (e) => {
        setValues({ ...values, txt_clVerifyRemarks: e.target.value });
    }


    //getDatas
    const getDrpData = async () => {
        BillingService.getImporterDetails().then((res) => {
            setImporterDetails(res.data);
        })
    }

    const getJobNoConsoleNonUpload = (val, val2) => {
        var consigmnt, importer_iec_no = '';
        if (val2 === '') { consigmnt = '-1' }
        else { consigmnt = val2 }
        if (val === '') { importer_iec_no = '-1'; }
        else { importer_iec_no = val; }
        let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '4' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonUplodedetails(res.data); });
        BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setUplodedetails(res.data); });
    }

    const getData = async () => {
        BillingService.getnonAudit('4').then((res) => { setnonUplodedetails(res.data); });
        BillingService.getAudit('4').then((res) => { setUplodedetails(res.data); });
    }

    const getConsignmentJobEntryAssign = (val) => {
        BillingService.getJobDetailsAssign(val).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            var MawbNo, AirlinesName, HawbNo = '';
            if (lastResult[0].transitTypeName === 'AIR') {
                MawbNo = 'MAWB.No';
                AirlinesName = 'AirlinesName';
                HawbNo = 'HAWB.No'
            } else if (lastResult[0].transitTypeName === 'SEA') {
                MawbNo = 'MBL.No';
                AirlinesName = 'ShipmentCompany';
                HawbNo = 'HBL.No'
            }
            setjobentryDetails({
                ...jobentryDetails, txt_asJobNo: lastResult[0].consignmentNumber, txt_asMawbNo: lastResult[0].wayBillNumber, txt_asImporterName: lastResult[0].importer_name,
                txt_asImporterCode: lastResult[0].importer_iec_no, txt_asImporterState: lastResult[0].deliveryStateName, ta_asimporterAddress: lastResult[0].importerAddress, txt_asTransitType: lastResult[0].transitTypeName,
                txt_asAirlinesName: lastResult[0].shipmentCompanyName, txt_asOriginCountry: lastResult[0].countryName, txt_asOriginPort: lastResult[0].origin_portName, txt_asClearancePort: lastResult[0].destinationName,
                txt_asArrivalDate: lastResult[0].expectedArrivalDateTime, txt_asHawbNo: lastResult[0].hawb_no, lbl_asMawbNo: MawbNo, lbl_asAirlinesName: AirlinesName, lbl_asHawbNo: HawbNo
            });
        });
    }

    const getJobTrackingDetails = (val) => {
        ChecklistService.getJobTrackingDetails(val).then((res) => {
            setJobTrackingDetails(res.data);
        })
    }

    const getChecklistAPPVERISUBMISSION = (val) => {
        ChecklistService.getChecklistAPPVERISUBMISSION(val).then((res) => {
            const data = res.data;
            setChecklistAPPVERISUBMISSION(res.data)
            const lastResult = data.map((item) => item);
            if (!lastResult[0]) {
                setValues({
                    ...values, txt_clVerifyDate: getData(), txt_clVerifyRemarks: '',
                    txt_clVerifySts: ''
                })
            } else {
                setValues({
                    ...values, txt_clVerifySts: lastResult[0].verificationStatus,
                    txt_clVerifyDate: lastResult[0].verificationDate, txt_clVerifyRemarks: lastResult[0].verificationRemarks
                })
            }
        });
    }

    useEffect(() => {
        getData();
        getDrpData();
    }, []);

    const [JobEntryOpen, setJobEntryOpen] = useState(false);

    //TableClick
    const [selected, setSelected] = useState([]);
    const editNonSumitedDetails = (item) => {
        const selectedIndex = selected.indexOf(item.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, item.consignmentNumber);
        }
        setSelected(newSelected);
        setConsigment(item.consignmentNumber);
        setChecklistAPPVERISUBMISSION([]);
        getConsignmentJobEntryAssign(item.consignmentNumber);
        getJobTrackingDetails(item.consignmentNumber);

    }
    const isSelected = (name) => selected.indexOf(name) !== -1;
    const editSumitedDetails = (item) => {
        const selectedIndex = selected.indexOf(item.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, item.consignmentNumber);
        }
        setSelected(newSelected);

        setConsigment(item.consignmentNumber);
        getConsignmentJobEntryAssign(item.consignmentNumber);
        getJobTrackingDetails(item.consignmentNumber);
        getChecklistAPPVERISUBMISSION(item.consignmentNumber);

    }
    const isUplodeSelected = (name) => selected.indexOf(name) !== -1;

    //clickEvents
    const [saveDsa, setSaveDsa] = useState(false);
    const [processing, setprocessing] = useState(false);
    const search = () => {
        getJobNoConsoleNonUpload(values.txt_customer, values.txt_jobNo)
    }

    const update = () => {
        if (consigment !== '') {
            if (values.txt_clVerifySts !== '') {
                setSaveDsa(true); setprocessing(true);
                let details = {
                    consignmentId: consigment, verificationStatus: values.txt_clVerifySts, verificationDate: values.txt_clVerifyDate,
                    verificationRemarks: values.txt_clVerifyRemarks, createdBy: getUserId(), pointId: getPointId()
                }
                ChecklistService.updateChecklistVerification(details).then((res) => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setOpen(true); setSeverity('success'); setMessage(message);
                    } else {
                        setOpen(true); setSeverity('error'); setMessage('Update Failed ' + message);
                    } refresh();
                }).catch((error) => {
                    setOpen(true); setSeverity('success'); setMessage('Update Failed ' + error.message); refresh();
                });
            } else {
                setOpen(true); setSeverity('warning'); setMessage('Kindly Select CL Verifi STS..!!')
            }
        } else {
            setOpen(true); setSeverity('warning'); setMessage('Kindly Select Job Tabel..!!')
        }
    }

    const refresh = () => {
        setSaveDsa(false); setprocessing(false);
        setValues({
            ...values, txt_customer: '', txt_jobNo: '', txt_clVerifySts: '', txt_clVerifyDate: getDate(),
            txt_clVerifyRemarks: ''
        });
        setjobentryDetails({
            ...jobentryDetails, txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
            ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '',
            txt_asClearancePort: '', txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: 'MAWB.No', lbl_asAirlinesName: 'AirlinesName',
            lbl_asHawbNo: 'HAWB.No',
        });
        setJobTrackingDetails([]); setChecklistAPPVERISUBMISSION([]);
        getData();
    }

    //handleClose/open
    const handleClose = () => { setOpen(false); setSeverity(''); setMessage(''); }

    const JobEntryOnCloseHandle = () => {
        setJobEntryOpen(false);
    }
    const JobEntryOpenHandle = () => {
        setJobEntryOpen(true);
    }
    const navigate = useNavigate();
    const BackBotton = () => {
        navigate('/checklistSndParty');
    }
    const ForwordBotton = () => {
        navigate('/customactivity');
    }
    return (
        <div>
            <Home /> <Snacbar open={open} message={message} severity={severity} onClose={handleClose} />

            <Dialog open={JobEntryOpen} onClose={JobEntryOnCloseHandle} fullWidth={true} maxWidth="lg">
                <DialogTitle className='p-1' style={{ backgroundColor: '#81d4fa', fontWeight: 'bolder' }}><center><label>
                    Job Entry Details</label></center></DialogTitle>
                <ItemPap1>
                    <Row className='mt-1'>
                        <Col className='jobentrAssign' xs={4}>
                            <Row xs={5}>
                                <Col xs={5}><label style={jobentrylablestyle}>Job No</label></Col>
                                <Col className='jobentrAssign' ><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asJobNo} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={5}><label style={jobentrylablestyle}>MAWB.NO</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asMawbNo} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={5}><label style={jobentrylablestyle}>Importer Name</label></Col>
                                <Col className='jobentrAssign' ><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterName} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={5}><label style={jobentrylablestyle}>Importer Code</label></Col>
                                <Col className='jobentrAssign summurry'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterCode} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={5}><label style={jobentrylablestyle}>Importer State</label></Col>
                                <Col className='jobentrAssign summurry'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterState} /></Col>
                            </Row>
                        </Col>

                        <Col className='jobentrAssign'>
                            <Row xs={5}>
                                <Col xs={5}><label style={jobentrylablestyle}>Importer Address</label></Col>
                                <Col className='jobentrAssign'><textarea rows="4" cols="17" disabled className='textAreaummurry scrollbarPrime'>{':' + jobentryDetails.ta_asimporterAddress}</textarea></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>Transit Type</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asTransitType} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>AirLines Name</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asAirlinesName} /></Col>
                            </Row>
                        </Col>
                        <Col className='jobentrAssign'>
                            <Row xs={5}>
                                <Col xs={4}><label style={jobentrylablestyle}>Origin Country</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asOriginCountry} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>Origin Port</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asOriginPort} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>Clearance Port</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asClearancePort} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>Arrival Date</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asArrivalDate} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>HAWB.No</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asHawbNo} /></Col>
                            </Row>
                        </Col>
                    </Row>
                </ItemPap1>
            </Dialog>
            {/* ////</div></div> */}
            <div style={{ paddingLeft: '80px' }} className='bg-light'>
            <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
                <Grid container>
                    <Grid item xs={2}>
                        <ItemPap style={{ height: 428 }}>
                            {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt'  size="small" > 
                        <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px',marginLeft:'5px' }}/> </ToggleButton> */}
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '13px', fontWeight: 'bold', color: 'red', marginLeft: '15px' }}>NonVerified Job</lable>
                            <TableContainer sx={{ maxHeight: 380 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Sl No</StyledTableCell>
                                            <StyledTableCell align='center'>Job No</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {nonUplodedetails.map((item) => {
                                            const isItemSelected = isSelected(item.consignmentId);
                                            return (
                                                <TableRow hover key={item.consignmentId} tabIndex={-1} selected={isItemSelected} onClick={() => editNonSumitedDetails(item)}>
                                                    <StyledTableCell align='center'>{item.serialNumber}</StyledTableCell>
                                                    <StyledTableCell align='center'>{item.consignmentNumber}</StyledTableCell>
                                                </TableRow>)
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </ItemPap>
                    </Grid>
                    <Grid item xs={8}>
                        <Grid container>
                            <ItemPap style={{ height: 428 }}>
                                <div className='form-inline mt-2 mb-2 p-1'>
                                    <Row>
                                        <center className='mb-3 mt-2'><lable style={{ fontFamily: 'Times New Roman', fontSize: '25px', fontWeight: 'bold', color: 'red', marginBottom: '2%' }}>CHECK LIST VERIFY BY CUSTOMER</lable></center>
                                        <Col></Col>
                                        <Col style={{textAlign:'right'}}>
                                            <Form.Label style={{ fontFamily: 'Times New Roman', color: 'darkblue', fontWeight: 'bold', }}>Customer</Form.Label>
                                        </Col>
                                        <Col xs={3}>
                                            <Form.Select style={{ fontFamily: 'Times New Roman', height: '26px', fontWeight: 'bold', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center' }} size='sm' value={values.txt_customer} onChange={CustomerChangeHandle}>
                                                <option value=''></option>
                                                {ImporterDetails.map((item) => (
                                                    <option key={item.serialNumber} value={item.importer_iec_no}>{item.importer_name}</option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                        <Col style={{textAlign:'right'}}>
                                            <Form.Label style={{ fontFamily: 'Times New Roman', color: 'darkblue', fontWeight: 'bolder', }}>Job.No</Form.Label>
                                        </Col>
                                        <Col xs={2}>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', height: '26px', fontWeight: 'bold', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center' }} value={values.txt_jobNo} onChange={JobNoChangeHandle} />
                                        </Col>
                                        <Col>
                                            <Button variant='contained' style={{ fontFamily: 'Times New Roman', }} size='small' onClick={search}>search</Button>
                                        </Col>
                                        <Col></Col>
                                    </Row>
                                </div>
                                <Row className='mt-3'>
                                    <Col></Col>
                                    <Col style={{textAlign:'right'}}>
                                        <Form.Label className='billingIpTitle' style={{ color: 'red' }}>CL Verify Status</Form.Label>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', fontWeight: 'bold', height: '26px' }} className='cntrtxt' value={values.txt_clVerifySts} onChange={ClVerifyStsChangeHandle}
                                            id='approvalSts'>
                                            <option value={''}></option>
                                            <option value={'YES'}>YES</option>
                                            <option value={'NO'}>NO</option>
                                        </Form.Select>
                                    </Col>
                                    <Col></Col>
                                </Row>
                                <Row className='mt-3'>
                                    <Col></Col>
                                    <Col style={{textAlign:'right'}}>
                                        <Form.Label className='billingIpTitle'>CL Verify Date</Form.Label>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', fontWeight: 'bold', height: '26px' }} type='date' className='cntrtxt' value={values.txt_clVerifyDate} onChange={ClverifyDateChangeHandle} />
                                    </Col>
                                    <Col></Col>
                                </Row>
                                <Row className='mt-3'>
                                    <Col></Col>
                                    <Col style={{textAlign:'right'}}>
                                        <Form.Label className='billingIpTitle'>CL Ver.Remarks</Form.Label>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Control style={{ fontWeight: 'bold', border: '1px solid black' }} as='textarea' rows='3' className='cntrtxt' value={values.txt_clVerifyRemarks} onChange={ClVerifyRemarksChangeHandle} />
                                    </Col>
                                    <Col></Col>
                                </Row>
                                <center><div className='mt-5'>
                                    <Button variant='contained' style={{ fontFamily: 'Times New Roman' }} color='primary' size='small' disabled={saveDsa} onClick={update}>{processing ? 'processing' : 'UPDATE'}</Button>{' '}

                                    <Button variant='contained' style={{ fontFamily: 'Times New Roman' }} color='warning' size='small' onClick={refresh}>REFRESH</Button>{' '}

                                    <Button variant='contained' style={{ fontFamily: 'Times New Roman' }} color='primary' size='small' onClick={JobEntryOpenHandle}>OPEN JOB ENTRY DETAILS</Button>{' '}
                                </div></center>
                            </ItemPap>
                        </Grid>
                    </Grid>
                    <Grid item xs={2}>
                        <ItemPap2 style={{ height: 428 }}>
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '13px', fontWeight: 'bold', color: 'red', marginRight: '30px' }}>Verified Job</lable>
                            {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>  
                            <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px'}} /> </ToggleButton>  */}
                            <TableContainer sx={{ maxHeight: 380 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered' >
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Sl No</StyledTableCell>
                                            <StyledTableCell align='center'>Job No</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Uplodedetails.map((item) => {
                                            const isItemSelected = isUplodeSelected(item.consignmentId);
                                            return (
                                                <TableRow hover key={item.consignmentId} tabIndex={-1} selected={isItemSelected} onClick={() => editSumitedDetails(item)}>
                                                    <StyledTableCell align='center'>{item.serialNumber}</StyledTableCell>
                                                    <StyledTableCell align='center'>{item.consignmentNumber}</StyledTableCell>
                                                </TableRow>)
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </ItemPap2>
                    </Grid>
                    <Grid item xs={6} >
                        <ItemPap>
                            <TableContainer sx={{ height: 204 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered' >
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>JobNo</StyledTableCell>
                                            <StyledTableCell align='center'>CheclistNo</StyledTableCell>
                                            <StyledTableCell align='center'>ClApprovalSts</StyledTableCell>
                                            <StyledTableCell align='center'>ClApprovalDate</StyledTableCell>
                                            <StyledTableCell align='center'>ClApprovalRemarks</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {ChecklistAPPVERISUBMISSION.map((item) => (
                                            <TableRow hover key={item.consignmentId} >
                                                <StyledTableCell align='center'>{item.consignmentId}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.checklistNo}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.approvalStatus}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.approvalDate}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.approvalRemarks}</StyledTableCell>
                                            </TableRow>))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </ItemPap>
                    </Grid>
                    <Grid item xs={6}>
                        <ItemPap>
                            <center> <lable style={{ fontFamily: 'Times New Roman', fontSize: '16px', fontWeight: 'bold', color: 'red' }}>Job Tracking Details</lable></center>
                            <TableContainer sx={{ height: 180 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered' >
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Operation Location</StyledTableCell>
                                            <StyledTableCell align='center'>Operation Date</StyledTableCell>
                                            <StyledTableCell align='center'>Operation Status</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {JobTrackingDetails.map((item) => (
                                            <TableRow hover key={item.serialNumber} >
                                                <StyledTableCell align='center'>{item.userLocation}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.operationDate}</StyledTableCell>
                                                <StyledTableCell align='center'>{item.operationStatus}</StyledTableCell>
                                            </TableRow>))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </ItemPap>
                    </Grid>
                </Grid>
            </div>
        </div >
    )
}

export default CheckListVerify